import {lazy} from 'react';

const loadCMSAdmin = () => import('./CMSAdmin');
export const CMSAdmin = lazy(loadCMSAdmin);
